import { Box, chakra, Flex, Image, Text, Progress } from '@chakra-ui/react';
import AppCard from 'presentation/components/shared/card/AppCard';
import { Color } from 'presentation/theme/colorScheme';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import AppRoute from 'router/AppRoute';
import compensationLogo from 'assets/img/sketches/compensation.svg';

interface Props {
  amount: number;
  progress: number;
}
const GeneralCompensationCard: FC<Props> = ({ amount, progress, ...props }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const handleClick = (): void => {
    if (window.location.pathname === '/') {
        navigate(AppRoute.compensationList);
    }
  };

  return (
    <>
      <AppCard
        style={{ cursor: isHome ? 'pointer' : 'default' }}
        minH="130px"
        position='relative'
        p="15px"
        display="flex"
        justifyContent="space-between"
        bgImage="linear-gradient(180deg, #848484 0%, #323232 100%)"
        bgColor={Color.Primary500}
        onClick={() => handleClick()}
        {...props}
      >
        <Flex flexDirection="column" justifyContent="space-between" width='100%'>
          <Box>
            <Text mb="10px" color="white" fontSize="18px" fontWeight={700}>
              {t('compensationCardTitle')}
            </Text>
            <Text maxW="240px" color="white" fontSize={16}>
              {t('compensationCardText')}
            </Text>
            <Progress
                value={progress}
                mt='25px'
                width='100%'
                zIndex={5}
                position='relative'
                min={0}
                max={100}
                sx={{
                  backgroundColor: '#BEBEBE', // Цвет фона (не заполненная часть)
                  borderRadius: '34px', // Радиус углов
                  height: '16px', // Высота прогресс-бара
                  '& > div': {
                    backgroundColor: '#40D9B5', // Цвет заполненной части
                    borderRadius: '34px', // Радиус углов для заполненной части
                  },
                }}
            />
          </Box>
          <Text color="white" mt='10px' fontSize='14px' fontWeight='400' lineHeight='16.8px'>
            {t('balanceCompensation')} {Number(amount)} $
          </Text>
        </Flex>
        <Image position='absolute' borderRadius='20px' top='0' right='0' zIndex={0} src={compensationLogo} h="133px" w="197px" />
      </AppCard>
    </>
  );
};

export default chakra(GeneralCompensationCard);
